export default __webpack_public_path__ + "static/media/cp_geo_lb.675dd9cb.svg";